import $ from "jquery";
import moment from "moment-timezone";

import Sha1 from "./sha1";

const getYYYYMMDDHHMMSS = () => {
  return moment().tz("Asia/Tokyo").format("YYYYMMDDHHmmss");
};

const OrderDetail = () => ({
  toString: function () {
    let result =
      this.dtl_rowno +
      this.dtl_item_id +
      this.dtl_item_name +
      this.dtl_item_count +
      this.dtl_tax +
      this.dtl_amount +
      this.dtl_free1 +
      this.dtl_free2 +
      this.dtl_free3;
    //console.log("result", result);
    return result;
  },
});

const formBuild = (order) => {
  let connectUrl = "https://stbfep.sps-system.com/f01/FepBuyInfoReceive.do";
  let form = $("<form></form>", {
    action: connectUrl,
    target: "receiver",
    method: "POST",
    "accept-charset": "Shift-JIS",
  }).hide();
  let body = $("body");
  body.find("form").remove();
  body.append(form);
  form.append(
    $("<input>", {
      type: "hidden",
      name: "pay_method",
      value: order.pay_method,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "merchant_id",
      value: order.merchant_id,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "service_id",
      value: order.service_id,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "cust_code",
      value: order.cust_code,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "sps_cust_no",
      value: order.sps_cust_no,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "sps_payment_no",
      value: order.sps_payment_no,
    })
  );
  form.append(
    $("<input>", { type: "hidden", name: "order_id", value: order.order_id })
  );
  form.append(
    $("<input>", { type: "hidden", name: "item_id", value: order.item_id })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "pay_item_id",
      value: order.pay_item_id,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "item_name",
      value: order.item_name,
    })
  );
  form.append($("<input>", { type: "hidden", name: "tax", value: order.tax }));
  form.append(
    $("<input>", { type: "hidden", name: "amount", value: order.amount })
  );
  form.append(
    $("<input>", { type: "hidden", name: "pay_type", value: order.pay_type })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "auto_charge_type",
      value: order.auto_charge_type,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "service_type",
      value: order.service_type,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "div_settele",
      value: order.div_settele,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "last_charge_month",
      value: order.last_charge_month,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "camp_type",
      value: order.camp_type,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "tracking_id",
      value: order.tracking_id,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "terminal_type",
      value: order.terminal_type,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "success_url",
      value: order.success_url,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "cancel_url",
      value: order.cancel_url,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "error_url",
      value: order.error_url,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "pagecon_url",
      value: order.pagecon_url,
    })
  );
  form.append(
    $("<input>", { type: "hidden", name: "free1", value: order.free1 })
  );
  form.append(
    $("<input>", { type: "hidden", name: "free2", value: order.free2 })
  );
  form.append(
    $("<input>", { type: "hidden", name: "free3", value: order.free3 })
  );
  form.append(
    $("<input>", { type: "hidden", name: "free_csv", value: order.free_csv })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "request_date",
      value: order.request_date,
    })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "limit_second",
      value: order.limit_second,
    })
  );
  form.append(
    $("<input>", { type: "hidden", name: "hashkey", value: order.hashkey })
  );
  form.append(
    $("<input>", {
      type: "hidden",
      name: "sps_hashcode",
      value: order.sps_hashcode,
    })
  );

  for (let i = 0; i < order.orderDetail.length; i++) {
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_rowno",
        value: order.orderDetail[i].dtl_rowno,
      })
    );
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_item_id",
        value: order.orderDetail[i].dtl_item_id,
      })
    );
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_item_name",
        value: order.orderDetail[i].dtl_item_name,
      })
    );
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_item_count",
        value: order.orderDetail[i].dtl_item_count,
      })
    );
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_tax",
        value: order.orderDetail[i].dtl_tax,
      })
    );
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_amount",
        value: order.orderDetail[i].dtl_amount,
      })
    );
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_free1",
        value: order.orderDetail[i].dtl_free1,
      })
    );
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_free2",
        value: order.orderDetail[i].dtl_free2,
      })
    );
    form.append(
      $("<input>", {
        type: "hidden",
        name: "dtl_free3",
        value: order.orderDetail[i].dtl_free3,
      })
    );
  }
  // //console.log('form', form);
  // return false;
  form.submit();
};

const formSubmit = (data) => {
  let paymentmethod = data.payment_by;
  let timeRequest = getYYYYMMDDHHMMSS();
  console.log("data", data);
  const order = createOrder();
  order.pay_method = paymentmethod; //credit,paypay,rakuten
  // order.merchant_id           = "76116";
  order.merchant_id = "30132";
  order.service_id = "001";
  order.cust_code = "SPSSFA0000028840";
  order.sps_cust_no = "";
  order.sps_payment_no = "";
  order.order_id = data.order_id;
  order.item_id = "U_FRET";
  order.pay_item_id = "";
  order.item_name = "Product";
  order.tax = "";
  order.amount = data.totalPrice;
  order.pay_type = "0";
  order.auto_charge_type = "";
  order.service_type = "0";
  order.div_settele = "";
  order.last_charge_month = "";
  order.camp_type = "";
  order.tracking_id = "";
  order.terminal_type = "0";
  order.success_url = "http://stbfep.sps-system.com/MerchantPaySuccess.jsp";
  order.cancel_url = "http://stbfep.sps-system.com/MerchantPayCancel.jsp";
  order.error_url = "http://stbfep.sps-system.com/MerchantPayError.jsp";
  order.pagecon_url =
    "http://stbfep.sps-system.com/MerchantPayResultRecieveSuccess.jsp";
  order.free1 = "aaaa";
  order.free2 = "bbb";
  order.free3 = "ccc";
  order.free_csv_input = "";
  order.request_date = timeRequest;
  order.limit_second = "";
  //order.hashkey               = "ab3150b95269b5f893d8a08b33cca57daaf428cc";
  order.hashkey = "c48e0e2c7d04f0954594f14c7801bd430ca6263e";

  const orderDetail = OrderDetail();
  orderDetail.dtl_rowno = "1";
  orderDetail.dtl_item_id = "U_FRET";
  orderDetail.dtl_item_name = "U‐FRET";
  orderDetail.dtl_item_count = "1";
  orderDetail.dtl_tax = "1";
  orderDetail.dtl_amount = "1";
  orderDetail.dtl_free1 = "";
  orderDetail.dtl_free2 = "";
  orderDetail.dtl_free3 = "";
  order.orderDetail.push(orderDetail);
  order.free_csv = atob(order.free_csv_input, 1);
  order.sps_hashcode = Sha1.hash(order.toString());
  formBuild(order);
};

const createOrder = () => {
  const order = {
    orderDetail: [],
    toString: function () {
      let resultOrderDetail = "";
      for (let i = 0; i < this.orderDetail.length; i++) {
        resultOrderDetail += this.orderDetail[i].toString();
      }
      let result =
        this.pay_method +
        this.merchant_id +
        this.service_id +
        this.cust_code +
        this.sps_cust_no +
        this.sps_payment_no +
        this.order_id +
        this.item_id +
        this.pay_item_id +
        this.item_name +
        this.tax +
        this.amount +
        this.pay_type +
        this.auto_charge_type +
        this.service_type +
        this.div_settele +
        this.last_charge_month +
        this.camp_type +
        this.tracking_id +
        this.terminal_type +
        this.success_url +
        this.cancel_url +
        this.error_url +
        this.pagecon_url +
        this.free1 +
        this.free2 +
        this.free3 +
        this.free_csv +
        resultOrderDetail +
        this.request_date +
        this.limit_second +
        this.hashkey;
      return result;
    },
  };
  return order;
};

function paymentSubmit(data) {
    formSubmit(data);
}

export default paymentSubmit;
